import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MatchListCard from '../components/MatchListCard';
import "../styles/matchstats.css"

export default function MatchStats({ addToast }) {
    const navigate = useNavigate();
    const [matches, setMatches] = useState([])

    //TITLE BEÁLLITÁS
    useEffect(() => {
        document.title = "Napi foci statisztikák – Részletes elemzések | FociFanatik";

        const meta = document.querySelector("meta[name='description']");
        if (meta) {
            meta.setAttribute(
                "content",
                "Részletes napi tippmix statisztikák, csapat- és egymás elleni elemzések. Objektív adatok a tudatos fogadási döntésekhez."
            );
        }
    }, []);


    //STATISZTIKA MÉRKŐZÉSEK
    useEffect(() => {
        fetch("https://focifanatik.hu/api/get_statistics_matches.php")
            .then((response) => response.json())
            .then((data) => {
                console.log("Kapott adatok:", data); // ← ezzel látod a böngésző konzolban, hogy tényleg jön adat
                if (Array.isArray(data)) {
                    setMatches(data);
                } else {
                    setMatches([]); // ha nem tömb jön vissza, akkor üres tömb
                }
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, []);




    return (
        <div className="stats-page">
            {matches.length === 0 ? (
                <div className="stats-empty">
                    <div className="stats-empty-card">

                        <h2>Nincs még elérhető statisztika</h2>

                        <p>
                            A mai mérkőzések statisztikái még feldolgozás alatt vannak.
                            Az adatok automatikusan frissülnek, amint elérhetőek lesznek.
                        </p>

                    </div>
                </div>
            ) : (
                <div className="container py-4">

                    <div className="match-list">
                        {matches.map(match => (
                            <MatchListCard
                                key={match.id}
                                homeTeam={match.home_team_name}
                                awayTeam={match.away_team_name}
                                homeLogo={match.home_team_logo}
                                awayLogo={match.away_team_logo}
                                leagueLogo={match.league_logo_url}
                                league={match.league_name}
                                date={match.match_date}
                                onClick={() => navigate(`/meccselemzo/${match.slug}`)}
                            />
                        ))}
                    </div>

                </div>
            )}


        </div>
    );
}